import { Box } from "@mui/material";
import { DotLegalButton, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { RiskObservationSource } from "../../riskObservation/riskObservationDialog/RiskObservationDialog.types";
import { publicRiskObservationStyles as styles } from "../PublicRiskObservation.styles";
import SourceCard from "../sourceCard/SourceCard";

export interface ISourceStepProps {
    selectedSource: RiskObservationSource;
    sourceOptions: Array<{ source: RiskObservationSource; name: string; helperText: string; emoji: string }>;
    onSourceChange: (source: RiskObservationSource) => void;
    onBack: () => void;
    onContinue: () => void;
}

function SourceStep(props: ISourceStepProps) {
    const { translateString } = useTranslation();

    return (
        <>
            <Box sx={styles.content}>
                <DotLegalHeader headerStyle="extraLarge" marginBottom={0}>
                    {translateString("reportObservationSourceHeader")}
                </DotLegalHeader>
                <DotLegalHeader headerStyle="small" fontWeight={400} marginBottom={0}>
                    {translateString("reportObservationSourceText")}
                </DotLegalHeader>
                <Box sx={styles.sourceCardList} role="radiogroup" aria-label={translateString("source")}>
                    {props.sourceOptions.map((option) => (
                        <SourceCard
                            key={option.source}
                            name={option.name}
                            helperText={option.helperText}
                            emoji={option.emoji}
                            isSelected={option.source === props.selectedSource}
                            onClick={() => props.onSourceChange(option.source)}
                        />
                    ))}
                </Box>
            </Box>
            <Box sx={styles.footer}>
                <DotLegalButton buttonType="secondary" size="medium" onClick={props.onBack}>
                    {translateString("previous")}
                </DotLegalButton>
                <Box sx={styles.footerPrimary}>
                    <DotLegalButton buttonType="primary" size="medium" fullWidth onClick={props.onContinue}>
                        {translateString("continue")}
                    </DotLegalButton>
                </Box>
            </Box>
        </>
    );
}

export default SourceStep;
